import React from 'react';

const LoanSearchConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  routes: [
    {
      path: '/loan/search',
      component: React.lazy(() => import('./LoanSearch'))
    }
  ]
};
export default LoanSearchConfig;
